import { normalizeKind } from "./camera";
import type { SnapshotEntity } from "./types";

export function renderOrder(entity: SnapshotEntity): number {
  const kind = normalizeKind(entity.kind);

  switch (kind) {
    case "damagezone":
      return 0;
    case "heart":
      return 1;
    case "projectile":
      return 2;
    case "zombie":
      return 3;
    case "player":
    case "bot":
      return 4;
    case "orbitingball":
      return 5;
    default:
      return 6;
  }
}